import { render, staticRenderFns } from "./CompanyInvoicing.vue?vue&type=template&id=51ff95a8&scoped=true&"
import script from "./CompanyInvoicing.vue?vue&type=script&lang=js&"
export * from "./CompanyInvoicing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ff95a8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ff95a8')) {
      api.createRecord('51ff95a8', component.options)
    } else {
      api.reload('51ff95a8', component.options)
    }
    module.hot.accept("./CompanyInvoicing.vue?vue&type=template&id=51ff95a8&scoped=true&", function () {
      api.rerender('51ff95a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoices/CompanyInvoicing.vue"
export default component.exports